import 'isomorphic-fetch';
import { configJson } from '../config/forms-configs';


export async function fetchApiConfig(): Promise<string> {
  const response = await fetch(`${configJson.url}/apiConfig`);
  if (!response.ok) {
    throw new Error('Failed to fetch API key');
  }

  const data = await response.json();
  const decodedString = atob(data.base64Encoded);
  const appConfig = JSON.parse(decodedString);

  configJson.googleKey = appConfig;

  return appConfig;
}

